const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 961 966",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M210.268,731.344c-143.659,-143.659 -143.667,-377.417 -0,-521.075c143.658,-143.663 377.425,-143.659 521.079,-0c143.654,143.654 143.662,377.412 0,521.075c-143.662,143.662 -377.425,143.654 -521.079,-0Zm735.505,146.953l-107.918,-112.816c148.784,-184.875 137.492,-455.962 -34.137,-627.587c-183.863,-183.859 -481.959,-183.859 -665.821,-0c-183.863,183.862 -183.863,481.958 -0,665.821c171.621,171.625 442.717,182.916 627.588,34.137l107.913,112.816c20.005,19.983 52.421,19.983 72.375,-0c20.005,-19.988 20.005,-52.388 0,-72.371Z",
    style: {
      fill: "#2b2b2b",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/MagnifyingGlass.2425c169b733742b15ff4c503d07cd98.svg";
export { ForwardRef as ReactComponent };